// extracted by mini-css-extract-plugin
export default {"root":"pXt4i0","button":"Fh4nM6"};